import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

// Login Redux States
import { REMOVE_AREA_ENTRY_STRATEGY } from './actionTypes';
import { removeAreaEntryStrategySuccessful, removeAreaEntryStrategyFailed } from './actions';

// Include call API
import { getEntryStrategiesAPI } from '../../../api/entryestrategies';

const entryStrategiesAPI = getEntryStrategiesAPI();

function* removeAreaEntryStrategy({ payload: { token, areaId, history } }) {
  try {
    const response = yield call(entryStrategiesAPI.removeAreaEntryStrategy, {
      token,
      areaId,
    });
    yield put(removeAreaEntryStrategySuccessful(response.message));
    history.go();
  } catch (error) {
    yield put(removeAreaEntryStrategyFailed(error.message || error));
  }
}

export function* watchRemoveAreaEntryStrategy() {
  yield takeEvery(REMOVE_AREA_ENTRY_STRATEGY, removeAreaEntryStrategy);
}

function* removeAreaEntryStrategySaga() {
  yield all([fork(watchRemoveAreaEntryStrategy)]);
}

export default removeAreaEntryStrategySaga;
